import { render } from "./ResidencesView.vue?vue&type=template&id=7405e246"
import script from "./ResidencesView.vue?vue&type=script&lang=js"
export * from "./ResidencesView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Documents\\MetaLuxe\\projects\\website-template\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__